/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { supportCreateCreate } from '../fn/support/support-create-create';
import { SupportCreateCreate$Params } from '../fn/support/support-create-create';
import { BackendSupportRequestDto } from '../models/backend-support-request-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiSupportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `supportCreateCreate()` */
  static readonly SupportCreateCreatePath = '/api/support/create/';

  /**
   * Запросить поддержку.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `supportCreateCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  supportCreateCreate$Response(
    params?: SupportCreateCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSupportRequestDto>> {
    return supportCreateCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Запросить поддержку.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `supportCreateCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  supportCreateCreate(
    params?: SupportCreateCreate$Params,
    context?: HttpContext,
  ): Observable<BackendSupportRequestDto> {
    return this.supportCreateCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSupportRequestDto>): BackendSupportRequestDto => r.body),
    );
  }
}
